<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="500">
        <v-form class="mb-3" validate-on="input lazy" @submit.prevent="updateMenuGroup">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Update Menu Group</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData['title']" autofocus
                                          :rules="[vRules.required]" density="compact" label="Title"/>
                            <v-text-field v-model="formData['key']"
                                          :rules="[vRules.required]" density="compact" label="Key"/>
                            <v-select v-model="formData['type']" :items="['admin','company']" :rules="[vRules.required]"
                                      class="text-capitalize" density="compact" label="Type"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    menuGroup: {
        type: Object
    }
});

const formData = reactive({
    valid: false,
    key: props.menuGroup.key ?? null,
    type: props.menuGroup.type ?? null,
    title: props.menuGroup.title ?? null,
});
const emits = defineEmits(['update:modelValue', 'updateMenuGroup']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);

const updateMenuGroup = () => {
    errors.value = [];
    send('put', `admin/menu-groups/${props.menuGroup.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateMenuGroup', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
